import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from 'src/app/core/services/core.service';
import { ManageUsersService } from 'src/app/modules/manage-users/services/manage-users.service';
import {
  CP_QP_ROLE,
  CP_QP_ORC_ROLE,
  ORC_ROLE,
  ENDORSER_ROLE,
  ENDUSER_ROLE,
} from '../../constants/constant';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-full-screen-popup',
  templateUrl: './full-screen-popup.component.html',
  styleUrls: ['./full-screen-popup.component.scss'],
})
export class FullScreenPopupComponent implements OnInit, OnChanges, OnDestroy {
  @Input() header: string;
  @Input() type: string;
  @Input() buttonText: string;
  @Input() workflowStatus: string;
  @Input() workflowUser: string;
  @Input() formName: string;
  @Input() readonlyForm = false;
  @Input() yearCode: string;

  public isReportingCycleLocked: boolean = false;
  public loginUserId: number;
  public userRole: string;
  public isORC: boolean = false;
  public isCPQPORC: boolean = false;
  public isEndorser: boolean = false;
  public showNominationButton: boolean = true;
  public loginID: number;
  public affiliationNotPreset: boolean = false;
  public disableNominationToolTip: string =
    'There is no affiliation for your profile. Nomination cannot be submitted without uploading at least 1 affiliation.';

  @Output() onClose = new EventEmitter();
  @Output() onSubmitNomination = new EventEmitter();
  @Output() onEndorserReject = new EventEmitter();
  @Output() onORCApprove = new EventEmitter();
  @Output() onEndorserApprove = new EventEmitter();
  @Output() rejectUpdateRequired = new EventEmitter();
  @Output() rejectApplicant = new EventEmitter();
  currentReportingCycleYear: string;
  constructor(
    private coreService: CoreService,
    private router: Router,
    private manageUsersService: ManageUsersService,
    private authService: AuthService
  ) {
    this.currentReportingCycleYear = sessionStorage.getItem(
      'currentReportingCycleYear'
    );
  }

  ngOnInit(): void {
    this.currentReportingCycleYear = sessionStorage.getItem(
      'currentReportingCycleYear'
    );
    this.getAffiliationStatus();
    if (this.router.url.indexOf('view-manage-workflows') > -1) {
      this.showNominationButton = false;
    }
    this.loginUserId = this.coreService.getLoggedInID();
    document.body.style.overflow = 'hidden';
  }

  ngOnChanges(): void {
    this.userRole = this.authService.getUserRoles();
    this.isReportingCycleLocked =
      sessionStorage.getItem('isCurrentReportingCycleYearLock') === '1';
    if (this.userRole && this.userRole.length) {
      const userRole = this.userRole[0].toLowerCase();
      if (
        (userRole === CP_QP_ROLE || userRole === ORC_ROLE) &&
        this.workflowStatus === '1'
      ) {
        this.isCPQPORC = true;
      } else if (
        (userRole === CP_QP_ORC_ROLE || userRole === ORC_ROLE) &&
        this.workflowStatus === '2'
      ) {
        this.isORC = true;
      } else if (
        (userRole === ENDORSER_ROLE || userRole === ENDUSER_ROLE) &&
        (this.workflowStatus === '4' || this.workflowStatus === '6')
      ) {
        this.isEndorser = true;
      }
    }
  }

  ngOnDestroy(): void {
    document.body.style.overflow = 'auto';
  }

  public getAffiliationStatus(): void {
    this.loginID = this.coreService.getLoggedInID();
    this.manageUsersService
      .getAffiliationData(this.loginID)
      .subscribe((response) => {
        if (response && !response.length) {
          this.affiliationNotPreset = true;
        } else {
          this.affiliationNotPreset = false;
        }
      });
  }
}
